<template>
  <div class="list-wrap">
    <el-card class="list-body">
      <!-- 顶部按钮区域 -->
      <el-row class="common-con-btns mb10">
        <el-button size="small" type="primary" class="fresh-btn" @click="fresh">刷新</el-button>
        <el-button size="small" type="primary" class="fresh-btn" @click="exportUser">导出</el-button>
      </el-row>
      <!-- 筛选区域 -->
      <el-form :inline="true" :model="search" ref="searchForm" size="mini">
        <el-form-item label="筛选"></el-form-item>
        <el-form-item>
          <el-input class="select-input" placeholder="用户id" size="mini" v-model="search.ac_id"></el-input>
        </el-form-item>
        <el-form-item
          :rules="[{ min:11,max:11, message: '请填写11位的手机号',trigger: 'blur'}]"
          prop="mobile"
        >
          <el-input class="select-input" placeholder="手机号" size="mini" v-model="search.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="nickname">
          <el-input class="select-input" placeholder="微信昵称" size="mini" v-model="search.nickname"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="search.platform_id" placeholder="所属平台" clearable size="mini">
            <el-option
                v-for="item in platformList"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch" size="mini" type="primary">筛选</el-button>
          <el-button @click="onReset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域 -->
      <el-table
        :data="dataList"
        @sort-change="sortChange"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="listTable"
        ref="listTable"
        style="width: 100%"
      >
        <el-table-column label="用户id" prop="ac_id"></el-table-column>
        <el-table-column label="微信信息" prop="traceable_code">
          <template slot-scope="scope">
            <div class="avatar-box">
              <img :src="scope.row.avatar" alt class="avatar" />
              <p>{{scope.row.nickname}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="个人信息" min-width="100">
          <template slot-scope="scope">
            <p>
              姓名：
              <span>{{scope.row.name}}</span>
            </p>
            <p v-if="scope.row.gender">
              性别：
              <span>{{ scope.row.gender | filterGender }}</span>
            </p>
            <p>
              手机：
              <span>{{scope.row.mobile}}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="平台" min-width="100">
          <template slot-scope="scope">
            {{ platformList.find(v => { return v.key == scope.row.platform_id }) ? platformList.find(v => { return v.key == scope.row.platform_id }).value : '' }}
          </template>
        </el-table-column>
        <el-table-column label="绑定门店">
          <template slot-scope="scope">
            <div v-if="scope.row.shops">
              <el-tag type="info" v-for="item in scope.row.shops" :key="item.id">{{item.name}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="积分余额" prop="score"></el-table-column>
        <el-table-column
          label="领取积分次数"
          prop="total_obtain_score_num"
          sortable="custom"
          min-width="125"
        ></el-table-column>
        <el-table-column label="累计获得积分" prop="total_obtain_score" sortable="custom" min-width="125"></el-table-column>
        <el-table-column label="核销次数" prop="total_use_num" sortable="custom" min-width="100"></el-table-column>
        <el-table-column label="累计优惠金额" prop="total_use_money"></el-table-column>
        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <el-switch
              :active-value="1"
              :inactive-value="2"
              @change="onChangeUserStatus(scope.row)"
              active-color="#13ce66"
              inactive-color="#999"
              v-model="scope.row.status"
            ></el-switch>
            <span class="ml5" style="vertical-align: middle;">{{scope.row.status==1?'正常':'停用'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <el-button @click="toDetail(scope.row.ac_id)" size="mini" type="text">详情</el-button>
            <el-button @click="showScoreLog(scope.row.ac_id)" size="mini" type="text">积分记录</el-button>
            <el-button @click="showRemark(scope.row.ac_id)" size="mini" type="text">修改积分</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          :page-size="page.pageSize"
          :total="page.total"
          @current-change="onChangePage"
          background
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 编辑积分 -->
    <el-dialog :visible.sync="remark.show" title="修改积分" width="500px">
      <el-form :model="remark" label-width="80px" ref="remarkForm">
        <el-form-item :rules="{required: true, message: '请填写变更积分'}" label="变更积分" prop="score">
          <el-input placeholder="输入增加的积分数（输入负数扣除）" v-model="remark.score"></el-input>
        </el-form-item>
        <el-form-item :rules="{required: true, message: '请填写操作原因'}" label="操作原因" prop="reason">
          <el-input placeholder="输入操作原因" type="textarea" v-model="remark.reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer ftc" slot="footer">
        <el-button @click="onRemark" type="primary">确认</el-button>
        <el-button @click="remark.show = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 积分记录 -->
    <el-dialog :visible.sync="scoreLog.show" title="积分变动记录" width="600px">
      <el-table
        :data="scoreLog.list"
        max-height="400"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="logTable"
        ref="logTable"
        style="width: 100%"
      >
        <el-table-column label="原因类型">
          <template slot-scope="scope">
            <p v-if="scope.row.reason_type==1">查询获得</p>
            <p v-else-if="scope.row.reason_type==2">兑换消费</p>
            <p v-else-if="scope.row.reason_type==3">客服修改</p>
          </template>
        </el-table-column>
        <el-table-column label="原因" prop="reason"></el-table-column>
        <el-table-column label="变动情况" prop="score" width="140">
          <template slot-scope="scope">
            <p>
              <span v-if="scope.row.change_type==1">+</span>
              <span v-else-if="scope.row.change_type==2">-</span>
              <span>{{scope.row.score}}（{{scope.row.after_score}}）</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column label="时间" prop="created_at" width="150"></el-table-column>
      </el-table>
      <div class="ftc mt10">
        <el-pagination
          :page-size="scoreLog.page.pageSize"
          :total="scoreLog.page.total"
          @current-change="onChangescoreLogPage"
          background
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="dialog-footer ftc" slot="footer">
        <el-button @click="scoreLog.show = false" type="primary">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { stickerApi } from "@/api/sticker";
import { clientUserApi } from "@/api/client_user/";
import lodash from "lodash";
const tempSearch = {
  ac_id: "", //	否	int	用户ID	筛选条件
  mobile: "", //	否	int	用户手机号	筛选条件
  nickname: "", // string 用户昵称
  platform_id:1,
  order: {
    total_obtain_score_num: "",
    total_obtain_score: "",
    total_use_num: ""
  }, //排序
};
export default {
  data() {
    return {
        platformList: [],
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },

      search: lodash.cloneDeep(tempSearch),
      options: {},
      dataList: [],
      scoreLog: {
        list: [],
        page: {
          currentPage: 1,
          pageSize: 50,
          total: 0
        },
        ac_id: null,
        show: false
      },
      remark: {
        ac_id: "",
        score: "",
        reason: "",
        show: false
      }
    };
  },
  created() {
    if (this.$route.query.ac_id) {
      this.search.ac_id = this.$route.query.ac_id;
    }
    this.getPlatformPermission()
    this.getList();
  },
  filters: {
    filterGender: function(value) {
      switch (value) {
        case 1:
          return "男";
        case 2:
          return "女";
        default:
          return "未知";
      }
    }
  },
  methods: {
    // 获取有权限的平台列表
    getPlatformPermission() {
        this.$EpetJs.Common.ajax('get', stickerApi.getPlatformPermissionUrl).then(res => {
            if(res) {
                this.platformList = res.data.data || []
                if(this.platformList.length > 0) {
                    this.search.platform_id = this.platformList[0].key
                }
            }
        })
    },
    /**
     * 获取列表
     */
    getList(page = 1) {
      const params = {
        page,
        per_page: this.page.pageSize,
        ...this.search
      };
      return this.$EpetJs.Common.get(clientUserApi.getUserList, params, {
        needLoading: true
      }).then(res => {
        if (res) {
          this.dataList = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total;
            this.page.currentPage = res.data.meta.pagination.current_page;
          }
        }
        return res;
      });
    },
    //导出用户
    exportUser() {
      const params = {
        ...this.search
      };
      this.$EpetJs.Common.get(clientUserApi.getExportUserListUrl, params).then(
        res => {
          if (res) {
            this.$message.success("操作成功，请去导出列表查看！");
          }
        }
      );
    },
    //刷新
    fresh() {
      this.getList();
    },
    //排序变化
    sortChange({ column, prop, order }) {
      console.log(column, prop, order);
      for (var k in this.search.order) {
        if (k == prop) {
          this.search.order[k] = order == "ascending" ? "asc" : "desc";
        } else {
          this.search.order[k] = "";
        }
      }
      this.getList();
    },
    /**
     * 积分变动记录 dialog
     */
    async showScoreLog(ac_id, page) {
      this.scoreLog.ac_id = ac_id;
      await this.getScoreLog(page);
      this.scoreLog.show = true;
    },
    getScoreLog(page = 1) {
      const params = {
        page,
        per_page: this.scoreLog.page.pageSize,
        ac_id: this.scoreLog.ac_id
      };
      return this.$EpetJs.Common.get(
        clientUserApi.getScoreLog + this.scoreLog.ac_id + "/score/log",
        params,
        {
          needLoading: true
        }
      ).then(res => {
        if (res) {
          this.scoreLog.list = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.scoreLog.page.total = res.data.meta.pagination.total;
            this.scoreLog.page.currentPage =
              res.data.meta.pagination.current_page;
          }
        }
        return res;
      });
    },
    /**
     * 修改积分
     */
    showRemark(ac_id) {
      this.remark = {
        show: true,
        ac_id,
        reason: "",
        score: ""
      };
      this.$nextTick(() => {
        this.$refs["remarkForm"].clearValidate();
      });
    },
    /**
     * 提交积分修改
     */
    async onRemark() {
      return this.$refs["remarkForm"].validate(async valid => {
        if (!valid) return;
        const params = {
          reason: this.remark.reason,
          score: this.remark.score,
          ac_id: this.remark.ac_id
        };
        await this.$EpetJs.Common.patch(
          clientUserApi.editScore + this.remark.ac_id,
          params,
          {
            needLoading: true
          }
        ).then(res => {
          console.log(res);
        });
        await this.getList(this.page.currentPage);
        this.remark.show = false;
      });
    },

    /**
     * 当前页改变
     */
    onChangePage(val) {
      this.getList(val);
    },
    /**
     * 积分记录列表翻页
     */
    onChangescoreLogPage(val) {
      this.getScoreLog(val);
    },
    /**
     * 筛选
     */
    onSearch() {
      this.$refs["searchForm"].validate(valid => {
        if (!valid) return;
        this.getList();
      });
    },
    /**
     * 重置
     */
    onReset() {
      this.search = lodash.cloneDeep(tempSearch);
      this.$refs.listTable.clearSort();
      this.getList();
    },

    /**改变用户状态 */
    async onChangeUserStatus(row) {
      const { ac_id, status } = row;
      let url;
      if (status == 1) {
        url = clientUserApi.enableStatus + ac_id;
      } else if (status == 2) {
        url = clientUserApi.disableStatus + ac_id;
      }
      await this.$EpetJs.Common.patch(url, {}, { needLoading: true }).then(
        res => {
          console.log(res);
        }
      );
      await this.getList(this.page.currentPage);
    },
    /**
     * 跳转详情页
     */
    toDetail(ac_id) {
      this.$router.push({
        path: "/client_user/detail/" + ac_id
      });
    }
  }
};
</script>
<style lang="less">
.select-input {
  width: 160px;
}
.cred {
  color: #ff0000;
}
.avatar-box {
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.avatar {
  width: 60px;
  height: 60px;
}
.list-wrap {
  .list-body {
    min-height: calc(100vh - 60px);
    .delete-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
    .detail-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
</style>
